import { media, styled } from '@pulse-web-ui/theme';

export const Container = styled.div`
  display: flex;
  padding-top: 8px;

  > button {
    width: 100%;
  }

  ${media.desktop} {
    > button {
      width: auto;
    }
  }
`;
